(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element
    ? event.target.closest('[data-lb404-cookie-settings]')
    : null;
  if (!button || button.getAttribute('aria-busy') === 'true') return;

  const message = document.getElementById(button.getAttribute('aria-describedby'));
  if (!message) return;

  message.textContent = '';
  button.setAttribute('aria-busy', 'true');
  button.setAttribute('aria-disabled', 'true');
  let timeoutId;

  try {
    if (typeof window.privacyBanner?.showPreferences !== 'function') {
      throw new Error('Cookie preferences unavailable');
    }

    await Promise.race([
      window.privacyBanner.showPreferences(),
      new Promise((resolve, reject) => {
        timeoutId = window.setTimeout(() => reject(new Error('Cookie preferences timeout')), 5000);
      })
    ]);
  } catch {
    message.textContent = button.dataset.cookieError;
  } finally {
    window.clearTimeout(timeoutId);
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
  }
});

  } catch(e) { console.error(e); }
})();
})();
